var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLetters(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.428571 15.1136C0.702857 14.9578 1.02859 14.9631 1.30287 15.1241L18 25.3547L34.6971 15.1241C34.9714 14.9631 35.2971 14.9578 35.5714 15.1136C35.8286 15.2693 36 15.5598 36 15.8748V35.125C36 35.608 35.6229 36 35.1429 36H0.857143C0.377143 36 0 35.608 0 35.125L0 15.8748C0 15.5598 0.171429 15.2693 0.428571 15.1136ZM1.71429 17.4201L1.71429 34.25H34.2857V17.4201L18.4457 27.1257C18.1714 27.2919 17.8286 27.2919 17.5543 27.1257L1.71429 17.4201Z",
    fill: "#00CFC5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.8544L5.2174 11L6.43471 12.1456L1.21731 17L0 15.8544ZM30.7826 11L36 15.8544L34.7827 17L29.5653 12.1456L30.7826 11Z",
    fill: "#00CFC5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0.826087C5 0.370087 5.36667 0 5.83333 0L29.1667 0C29.6333 0 30 0.370087 30 0.826087V19H28.3333V1.65217L6.66667 1.65217L6.66667 19H5L5 0.826087Z",
    fill: "#00CFC5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 12H10V10L26 10V12Z",
    fill: "#00CFC5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 17H10V15L26 15V17Z",
    fill: "#00CFC5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 7L10 7V5L26 5V7Z",
    fill: "#00CFC5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetters);
export default __webpack_public_path__ + "static/media/letters.f5b2239c6f69447772d95400c1231156.svg";
export { ForwardRef as ReactComponent };